import { useState } from "react"

export const UsageOverviewState = () => {

    const [form, setForm] = useState({
        department: {value: 0, stat: false, msg: ''},
        employee: {value: 0, first_name:'', middle_name:'', last_name:'', stat: false, msg: ''},
        interval: {value: 'daily', stat: false, msg: ''},
        date: {value: '', stat: false, msg: ''},
        sequence: {value: '4', stat: false, msg: ''},
        order: {value: '', stat: false, msg: ''},
        quarter: {value: '1st', stat: false, msg: ''},
    })

    const [graphDatasets, setGraphDatasets] = useState({
        label:[],
        dates:[]
    })

    const [toolUsageData, setToolUsageData] = useState({
        active_threshold:0,
        feature_data:[],
        loader:true
    })
    
    return {
        form: {data: form, set: setForm},
        graphDatasets: {data: graphDatasets, set: setGraphDatasets},
        toolUsageData: {data: toolUsageData, set: setToolUsageData},
    }
}